/**
 * Posicionamiento del caret (flecha) que apunta al elemento anclado, compartido
 * por el tooltip y el walkthrough. Floating UI (middleware `arrow`) da el
 * desplazamiento a lo largo del borde; aquí lo aplicamos y "pegamos" el caret al
 * lado del tooltip enfrentado al ancla.
 */

/** Lado del tooltip donde se "pega" el caret, opuesto al placement resuelto. */
const STATIC_SIDE: Record<string, 'top' | 'bottom' | 'left' | 'right'> = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left',
};

/**
 * Ubica el caret sobre el borde del tooltip enfrentado al ancla. Floating UI
 * da el desplazamiento a lo largo del borde (`x` o `y`); el otro eje se fija a
 * `-6px` (mitad del caret) para que sobresalga.
 */
export function positionArrow(
  arrowEl: HTMLElement,
  placement: string,
  data: { x?: number; y?: number } | undefined,
): void {
  const side = STATIC_SIDE[placement.split('-')[0] ?? 'bottom'] ?? 'top';
  for (const prop of ['top', 'bottom', 'left', 'right'] as const) {
    arrowEl.style.setProperty(prop, '');
  }
  if (data?.x != null) arrowEl.style.setProperty('left', `${data.x}px`);
  if (data?.y != null) arrowEl.style.setProperty('top', `${data.y}px`);
  arrowEl.style.setProperty(side, '-6px');
}
